module.exports = __webpack_public_path__ + "static/media/impressao-inteligente-250.25b766ec.jpg";